import { Injectable } from '@angular/core';
import { Company } from 'identity-webapi-client';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import { IHomeConfigShortcut } from '../views';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  private readonly cookiePrefix = 'SituPortal.State';
  private cookieName = this.cookiePrefix;

  private readonly stateSubject = new BehaviorSubject<IState>({} as IState);
  readonly state$ = this.stateSubject.asObservable();

  constructor(private cookieService: CookieService, private authService: AuthService) {
    this.authService.userSubject.subscribe((user) => {
      if (this.authService.isLoggedIn()) {
        this.cookieName = `${this.cookiePrefix}.${this.authService.getUserId()}`;
      }
      else {
        this.cookieName = this.cookiePrefix;
      }

      this.load();
    });
  }

  get state(): IState {
    return this.stateSubject.getValue();
  }

  set state(val: IState) {
    if (JSON.stringify(val) != JSON.stringify(this.state)) {
      this.stateSubject.next(val);
      this.save();
    }    
  }

  private save() {
    this.cookieService.set(this.cookieName, JSON.stringify(this.state));
  }

  private load() {
    const stateCookieValue = this.cookieService.get(this.cookieName);
    let state = {} as IState;

    if (stateCookieValue) {
      state = JSON.parse(stateCookieValue);
    }

    // set default values
    state.company = state.company ?? this.authService.getDefaultCompany();
    state.useDarkTheme = state.useDarkTheme ?? false;
    state.viewAsOpen = state.viewAsOpen ?? false;

    if (JSON.stringify(state) != JSON.stringify(this.state)) {
      this.stateSubject.next(state);
    }
  }
}

export interface IState {
  company: Company | null;
  useDarkTheme: boolean;
  viewAsOpen: boolean;
  homeHistory: IHomeConfigShortcut[];
}

